/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-broker-info',
  template: require('./fund-by-broker-info.component.html')
})

export class FundByBrokerInfoComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.flowManager.isUnlistedBroker = true;
    this.flowManager.isValidDTC = true;
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  hyperlinkClicked(event) {
    this.router.navigate(['/fund-by-broker-manual']);
  }

  btnClick(e) {
    if (e.action === 'next') {
      this.form.buttons.inputs.next.classes += ' spinner';
      this.form.buttons.inputs.next.disabled = true;
      this.form.buttons.inputs.back.disabled = true;
      this.flowManager.isValidDTC = true;
      const firmDTC = this.appActions.getData('Acats.acatsFirmDTC', {});
      const payload = { DTC: firmDTC };
      this.appProxy.validateDTCNumber(payload, resp => {
        if (resp.status === 200 && resp.result.valid === true) {
          this.flowManager.isValidDTC = true;
          this.router.navigate(['/fund-by-broker-review']);
        } else {
          this.flowManager.isValidDTC = false;
          this.form.buttons.inputs.next.classes = 'btn mobile-primary';
          this.form.buttons.inputs.next.disabled = false;
          this.form.buttons.inputs.back.disabled = false;
          this.validation.validateForm(this.form.inputs);
          this.flowManager.isValidDTC = true;
        }
      });

    } else if (e.action === 'back') {
      this.router.navigate(['/fund-by-broker-choose-firm']);
    } else if (e.action === 'fund_later') {
      this.flowManager.fundLaterRouting();
    }
  }

  ngOnDestroy() {
    this.flowManager.resetPageError();
  }
}
